// DoctorAvailabilityTestComponent.jsx
import React from 'react';
// import DoctorAvailabilityComponent from './DoctorAvailabilityComponent';
import SpeechToTextInput from '../../SpeechRecognition/speechRecognition.component';
import SpeechToTextFormInput from '../../SpeechRecognition/speechRecognitionFormInput';

const TestComponent = () => {
  return (
    <>
      {/* <h1>Doctor Availability Testing</h1>  */}
       {/* <DoctorAvailabilityComponent /> */}

      <div style={{margin:'300px'}}>
        <SpeechToTextInput/>
        <SpeechToTextFormInput type="textarea"/>
      </div>
    </>
  );
};

export default TestComponent;
